module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "plat-icon-flowListDialog",
    attrs: {
      "title": _vm.$_t('BUTTON_APPROVALPROGRESS', '审批进度'),
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "close": _vm.close
    }
  }, [(_vm.dialogVisible) ? _c('rt-flow-approval-list', {
    ref: "rtFlowApprovalList",
    attrs: {
      "id": _vm.entityId,
      "entityname": _vm.entityname
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b6085b5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/flowsubmit/src/flow-approval-dialog.vue
// module id = 2097
// module chunks = 228